import useSize from '~/modules/size/composables/useSize';
import useColor from '~/modules/color/composables/useColor';

export function useTraits() {
  const { selectedColor, selectedColorId } = useColor();
  const { selectedSize, selectedSizeId } = useSize();

  return {
    selectedColor,
    selectedSize,
    selectedColorId,
    selectedSizeId,
  };
}

export default useTraits;
